/**
 * Generato automaticamente.
 * framework-cmp-procedimenti
 */
import { useMutation, useQuery } from 'react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { apiClientRequest } from '../../../client/apiClient';
import type { ErrorType } from '../../../client/apiClient';
import type {
  BEResponseAttivitaDTO,
  BEResponseIstanzaProcedimentoDTO,
  BEResponseListProcedimento,
  BEResponseListTipologiaProcedimentoDTO,
  BEResponseProcedimentoConOggettiCollegati,
  BEResponseProcedimentoConTask,
  BEResponseRicercaProcedimentoResponseDTO,
  BEResponseWsRispostaPaginataListCollegamentoIstanzaDettaglioDTO,
  CampoEstraibileCSV,
  ChiudiEndoprocedimentoRequest,
  ComunicazioneDTO,
  CreaEndoprocedimentoRequest,
  CreaProcedimentoRequest,
  CreaScadenzaRequest,
  ElencoFileDocumento,
  EstrazioneDTO,
  GetBackProcedimentiB2BParams,
  GetBackProcedimentiCsvCampiParams,
  GetBackProcedimentiCsvParams,
  GetBackProcedimentiEstrazioneTipoEstrazioneParams,
  GetBackProcedimentiGeojson200,
  GetBackProcedimentiGeojsonParams,
  GetBackProcedimentiIdCollegamentiParams,
  GetBackProcedimentiIdComunicazioniParams,
  GetBackProcedimentiIdScadenzeParams,
  GetBackProcedimentiIdTipiComunicazioneParams,
  GetBackProcedimentiParams,
  GetBackProcedimentiTipiAvviabiliParams,
  GetBackProcedimentiTipiParams,
  GetBackProcedimentiXlsxParams,
  InvioVotazioneRequest,
  IstanzaProcedimento,
  OggettiCollegatiResponse,
  PersonaFisicaDTO,
  PraticaDomandaDTO,
  Procedimento,
  ScadenzaDTO,
  SubentroDTO,
  TipoComunicazioneDTO,
  TipoProcedimentoDettaglioUfficiAssociatiDTO,
  WsRispostaPaginataListComunicazioneDTO,
  WsRispostaPaginataListScadenzaDTO,
} from '.././schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

export const putBackProcedimentiIdAvvia = (
  idTipoProcedimento: string,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseAttivitaDTO>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idTipoProcedimento}/avvia`,
      method: 'put',
    },
    options,
  );
};

export const getPutBackProcedimentiIdAvviaMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putBackProcedimentiIdAvvia>>,
    TError,
    { idTipoProcedimento: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putBackProcedimentiIdAvvia>>,
  TError,
  { idTipoProcedimento: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putBackProcedimentiIdAvvia>>,
    { idTipoProcedimento: string }
  > = props => {
    const { idTipoProcedimento } = props ?? {};

    return putBackProcedimentiIdAvvia(idTipoProcedimento, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutBackProcedimentiIdAvviaMutationResult = NonNullable<
  Awaited<ReturnType<typeof putBackProcedimentiIdAvvia>>
>;

export type PutBackProcedimentiIdAvviaMutationError = ErrorType<unknown>;

export const usePutBackProcedimentiIdAvvia = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putBackProcedimentiIdAvvia>>,
    TError,
    { idTipoProcedimento: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getPutBackProcedimentiIdAvviaMutationOptions(options);

  return useMutation(mutationOptions);
};
export const putBackProcedimentiIdAvviaDaRichiesta = (
  idTipoProcedimento: string,
  creaProcedimentoRequest: CreaProcedimentoRequest,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseIstanzaProcedimentoDTO>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idTipoProcedimento}/avviaDaRichiesta`,
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      data: creaProcedimentoRequest,
    },
    options,
  );
};

export const getPutBackProcedimentiIdAvviaDaRichiestaMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putBackProcedimentiIdAvviaDaRichiesta>>,
    TError,
    { idTipoProcedimento: string; data: CreaProcedimentoRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putBackProcedimentiIdAvviaDaRichiesta>>,
  TError,
  { idTipoProcedimento: string; data: CreaProcedimentoRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putBackProcedimentiIdAvviaDaRichiesta>>,
    { idTipoProcedimento: string; data: CreaProcedimentoRequest }
  > = props => {
    const { idTipoProcedimento, data } = props ?? {};

    return putBackProcedimentiIdAvviaDaRichiesta(
      idTipoProcedimento,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PutBackProcedimentiIdAvviaDaRichiestaMutationResult = NonNullable<
  Awaited<ReturnType<typeof putBackProcedimentiIdAvviaDaRichiesta>>
>;
export type PutBackProcedimentiIdAvviaDaRichiestaMutationBody =
  CreaProcedimentoRequest;
export type PutBackProcedimentiIdAvviaDaRichiestaMutationError =
  ErrorType<unknown>;

export const usePutBackProcedimentiIdAvviaDaRichiesta = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putBackProcedimentiIdAvviaDaRichiesta>>,
    TError,
    { idTipoProcedimento: string; data: CreaProcedimentoRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPutBackProcedimentiIdAvviaDaRichiestaMutationOptions(options);

  return useMutation(mutationOptions);
};
export const putBackProcedimentiIdRiavviaProcedimento = (
  idIstanzaProcedimento: string,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseIstanzaProcedimentoDTO>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/riavviaProcedimento`,
      method: 'put',
    },
    options,
  );
};

export const getPutBackProcedimentiIdRiavviaProcedimentoMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putBackProcedimentiIdRiavviaProcedimento>>,
    TError,
    { idIstanzaProcedimento: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putBackProcedimentiIdRiavviaProcedimento>>,
  TError,
  { idIstanzaProcedimento: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putBackProcedimentiIdRiavviaProcedimento>>,
    { idIstanzaProcedimento: string }
  > = props => {
    const { idIstanzaProcedimento } = props ?? {};

    return putBackProcedimentiIdRiavviaProcedimento(
      idIstanzaProcedimento,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PutBackProcedimentiIdRiavviaProcedimentoMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof putBackProcedimentiIdRiavviaProcedimento>>
  >;

export type PutBackProcedimentiIdRiavviaProcedimentoMutationError =
  ErrorType<unknown>;

export const usePutBackProcedimentiIdRiavviaProcedimento = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putBackProcedimentiIdRiavviaProcedimento>>,
    TError,
    { idIstanzaProcedimento: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPutBackProcedimentiIdRiavviaProcedimentoMutationOptions(options);

  return useMutation(mutationOptions);
};
export const putBackProcedimentiIdEndoprocedimentiIdChiudi = (
  idIstanzaProcedimento: string,
  idIstanzaEndoprocedimento: string,
  chiudiEndoprocedimentoRequest: ChiudiEndoprocedimentoRequest,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseProcedimentoConTask>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/endoprocedimenti/${idIstanzaEndoprocedimento}/chiudi`,
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      data: chiudiEndoprocedimentoRequest,
    },
    options,
  );
};

export const getPutBackProcedimentiIdEndoprocedimentiIdChiudiMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putBackProcedimentiIdEndoprocedimentiIdChiudi>>,
    TError,
    {
      idIstanzaProcedimento: string;
      idIstanzaEndoprocedimento: string;
      data: ChiudiEndoprocedimentoRequest;
    },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putBackProcedimentiIdEndoprocedimentiIdChiudi>>,
  TError,
  {
    idIstanzaProcedimento: string;
    idIstanzaEndoprocedimento: string;
    data: ChiudiEndoprocedimentoRequest;
  },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putBackProcedimentiIdEndoprocedimentiIdChiudi>>,
    {
      idIstanzaProcedimento: string;
      idIstanzaEndoprocedimento: string;
      data: ChiudiEndoprocedimentoRequest;
    }
  > = props => {
    const { idIstanzaProcedimento, idIstanzaEndoprocedimento, data } =
      props ?? {};

    return putBackProcedimentiIdEndoprocedimentiIdChiudi(
      idIstanzaProcedimento,
      idIstanzaEndoprocedimento,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PutBackProcedimentiIdEndoprocedimentiIdChiudiMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof putBackProcedimentiIdEndoprocedimentiIdChiudi>>
  >;
export type PutBackProcedimentiIdEndoprocedimentiIdChiudiMutationBody =
  ChiudiEndoprocedimentoRequest;
export type PutBackProcedimentiIdEndoprocedimentiIdChiudiMutationError =
  ErrorType<unknown>;

export const usePutBackProcedimentiIdEndoprocedimentiIdChiudi = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putBackProcedimentiIdEndoprocedimentiIdChiudi>>,
    TError,
    {
      idIstanzaProcedimento: string;
      idIstanzaEndoprocedimento: string;
      data: ChiudiEndoprocedimentoRequest;
    },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPutBackProcedimentiIdEndoprocedimentiIdChiudiMutationOptions(options);

  return useMutation(mutationOptions);
};
export const putBackProcedimentiIdAggiornaDaRichiesta = (
  idIstanzaProcedimento: string,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<void>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/aggiornaDaRichiesta`,
      method: 'put',
    },
    options,
  );
};

export const getPutBackProcedimentiIdAggiornaDaRichiestaMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putBackProcedimentiIdAggiornaDaRichiesta>>,
    TError,
    { idIstanzaProcedimento: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putBackProcedimentiIdAggiornaDaRichiesta>>,
  TError,
  { idIstanzaProcedimento: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putBackProcedimentiIdAggiornaDaRichiesta>>,
    { idIstanzaProcedimento: string }
  > = props => {
    const { idIstanzaProcedimento } = props ?? {};

    return putBackProcedimentiIdAggiornaDaRichiesta(
      idIstanzaProcedimento,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PutBackProcedimentiIdAggiornaDaRichiestaMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof putBackProcedimentiIdAggiornaDaRichiesta>>
  >;

export type PutBackProcedimentiIdAggiornaDaRichiestaMutationError =
  ErrorType<unknown>;

export const usePutBackProcedimentiIdAggiornaDaRichiesta = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putBackProcedimentiIdAggiornaDaRichiesta>>,
    TError,
    { idIstanzaProcedimento: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPutBackProcedimentiIdAggiornaDaRichiestaMutationOptions(options);

  return useMutation(mutationOptions);
};
export const putBackProcedimentiPraticaIdTipiProcedimentoIdAvvia = (
  idIstanzaProcedimento: string,
  idTipoProcedimento: string,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseAttivitaDTO>(
    {
      url: `/framework-bo-procedimenti/procedimenti/pratica/${idIstanzaProcedimento}/tipi-procedimento/${idTipoProcedimento}/avvia`,
      method: 'put',
    },
    options,
  );
};

export const getPutBackProcedimentiPraticaIdTipiProcedimentoIdAvviaMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof putBackProcedimentiPraticaIdTipiProcedimentoIdAvvia>
      >,
      TError,
      { idIstanzaProcedimento: string; idTipoProcedimento: string },
      TContext
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof putBackProcedimentiPraticaIdTipiProcedimentoIdAvvia>
    >,
    TError,
    { idIstanzaProcedimento: string; idTipoProcedimento: string },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof putBackProcedimentiPraticaIdTipiProcedimentoIdAvvia>
      >,
      { idIstanzaProcedimento: string; idTipoProcedimento: string }
    > = props => {
      const { idIstanzaProcedimento, idTipoProcedimento } = props ?? {};

      return putBackProcedimentiPraticaIdTipiProcedimentoIdAvvia(
        idIstanzaProcedimento,
        idTipoProcedimento,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PutBackProcedimentiPraticaIdTipiProcedimentoIdAvviaMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof putBackProcedimentiPraticaIdTipiProcedimentoIdAvvia>
    >
  >;

export type PutBackProcedimentiPraticaIdTipiProcedimentoIdAvviaMutationError =
  ErrorType<unknown>;

export const usePutBackProcedimentiPraticaIdTipiProcedimentoIdAvvia = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof putBackProcedimentiPraticaIdTipiProcedimentoIdAvvia>
    >,
    TError,
    { idIstanzaProcedimento: string; idTipoProcedimento: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPutBackProcedimentiPraticaIdTipiProcedimentoIdAvviaMutationOptions(
      options,
    );

  return useMutation(mutationOptions);
};
export const postBackProcedimentiIdInviaVotazione = (
  idTipoProcedimento: string,
  invioVotazioneRequest: InvioVotazioneRequest,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseIstanzaProcedimentoDTO>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idTipoProcedimento}/inviaVotazione`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: invioVotazioneRequest,
    },
    options,
  );
};

export const getPostBackProcedimentiIdInviaVotazioneMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackProcedimentiIdInviaVotazione>>,
    TError,
    { idTipoProcedimento: string; data: InvioVotazioneRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackProcedimentiIdInviaVotazione>>,
  TError,
  { idTipoProcedimento: string; data: InvioVotazioneRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackProcedimentiIdInviaVotazione>>,
    { idTipoProcedimento: string; data: InvioVotazioneRequest }
  > = props => {
    const { idTipoProcedimento, data } = props ?? {};

    return postBackProcedimentiIdInviaVotazione(
      idTipoProcedimento,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackProcedimentiIdInviaVotazioneMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackProcedimentiIdInviaVotazione>>
>;
export type PostBackProcedimentiIdInviaVotazioneMutationBody =
  InvioVotazioneRequest;
export type PostBackProcedimentiIdInviaVotazioneMutationError =
  ErrorType<unknown>;

export const usePostBackProcedimentiIdInviaVotazione = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackProcedimentiIdInviaVotazione>>,
    TError,
    { idTipoProcedimento: string; data: InvioVotazioneRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackProcedimentiIdInviaVotazioneMutationOptions(options);

  return useMutation(mutationOptions);
};
export const getBackProcedimentiIdScadenze = (
  idIstanzaProcedimento: string,
  params?: GetBackProcedimentiIdScadenzeParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<WsRispostaPaginataListScadenzaDTO>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/scadenze`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiIdScadenzeQueryKey = (
  idIstanzaProcedimento: string,
  params?: GetBackProcedimentiIdScadenzeParams,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/scadenze`,
    ...(params ? [params] : []),
  ] as const;

export const getGetBackProcedimentiIdScadenzeQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdScadenze>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  params?: GetBackProcedimentiIdScadenzeParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdScadenze>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiIdScadenze>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackProcedimentiIdScadenzeQueryKey(idIstanzaProcedimento, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiIdScadenze>>
  > = ({ signal }) =>
    getBackProcedimentiIdScadenze(
      idIstanzaProcedimento,
      params,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!idIstanzaProcedimento,
    ...queryOptions,
  };
};

export type GetBackProcedimentiIdScadenzeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimentiIdScadenze>>
>;
export type GetBackProcedimentiIdScadenzeQueryError = ErrorType<unknown>;

export const useGetBackProcedimentiIdScadenze = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdScadenze>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  params?: GetBackProcedimentiIdScadenzeParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdScadenze>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackProcedimentiIdScadenzeQueryOptions(
    idIstanzaProcedimento,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postBackProcedimentiIdScadenze = (
  idIstanzaProcedimento: string,
  creaScadenzaRequest: CreaScadenzaRequest,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<ScadenzaDTO>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/scadenze`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: creaScadenzaRequest,
    },
    options,
  );
};

export const getPostBackProcedimentiIdScadenzeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackProcedimentiIdScadenze>>,
    TError,
    { idIstanzaProcedimento: string; data: CreaScadenzaRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackProcedimentiIdScadenze>>,
  TError,
  { idIstanzaProcedimento: string; data: CreaScadenzaRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackProcedimentiIdScadenze>>,
    { idIstanzaProcedimento: string; data: CreaScadenzaRequest }
  > = props => {
    const { idIstanzaProcedimento, data } = props ?? {};

    return postBackProcedimentiIdScadenze(
      idIstanzaProcedimento,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackProcedimentiIdScadenzeMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackProcedimentiIdScadenze>>
>;
export type PostBackProcedimentiIdScadenzeMutationBody = CreaScadenzaRequest;
export type PostBackProcedimentiIdScadenzeMutationError = ErrorType<unknown>;

export const usePostBackProcedimentiIdScadenze = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackProcedimentiIdScadenze>>,
    TError,
    { idIstanzaProcedimento: string; data: CreaScadenzaRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackProcedimentiIdScadenzeMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackProcedimentiIdEndoprocedimentiIdAvvia = (
  idIstanzaProcedimento: string,
  idTipoProcedimento: string,
  creaEndoprocedimentoRequest: CreaEndoprocedimentoRequest,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseAttivitaDTO>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/endoprocedimenti/${idTipoProcedimento}/avvia`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: creaEndoprocedimentoRequest,
    },
    options,
  );
};

export const getPostBackProcedimentiIdEndoprocedimentiIdAvviaMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackProcedimentiIdEndoprocedimentiIdAvvia>>,
    TError,
    {
      idIstanzaProcedimento: string;
      idTipoProcedimento: string;
      data: CreaEndoprocedimentoRequest;
    },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackProcedimentiIdEndoprocedimentiIdAvvia>>,
  TError,
  {
    idIstanzaProcedimento: string;
    idTipoProcedimento: string;
    data: CreaEndoprocedimentoRequest;
  },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackProcedimentiIdEndoprocedimentiIdAvvia>>,
    {
      idIstanzaProcedimento: string;
      idTipoProcedimento: string;
      data: CreaEndoprocedimentoRequest;
    }
  > = props => {
    const { idIstanzaProcedimento, idTipoProcedimento, data } = props ?? {};

    return postBackProcedimentiIdEndoprocedimentiIdAvvia(
      idIstanzaProcedimento,
      idTipoProcedimento,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackProcedimentiIdEndoprocedimentiIdAvviaMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postBackProcedimentiIdEndoprocedimentiIdAvvia>>
  >;
export type PostBackProcedimentiIdEndoprocedimentiIdAvviaMutationBody =
  CreaEndoprocedimentoRequest;
export type PostBackProcedimentiIdEndoprocedimentiIdAvviaMutationError =
  ErrorType<unknown>;

export const usePostBackProcedimentiIdEndoprocedimentiIdAvvia = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackProcedimentiIdEndoprocedimentiIdAvvia>>,
    TError,
    {
      idIstanzaProcedimento: string;
      idTipoProcedimento: string;
      data: CreaEndoprocedimentoRequest;
    },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackProcedimentiIdEndoprocedimentiIdAvviaMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackProcedimentiPraticaIdSubentro = (
  idIstanzaProcedimento: string,
  subentroDTO: SubentroDTO,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseAttivitaDTO>(
    {
      url: `/framework-bo-procedimenti/procedimenti/pratica/${idIstanzaProcedimento}/subentro`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: subentroDTO,
    },
    options,
  );
};

export const getPostBackProcedimentiPraticaIdSubentroMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackProcedimentiPraticaIdSubentro>>,
    TError,
    { idIstanzaProcedimento: string; data: SubentroDTO },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackProcedimentiPraticaIdSubentro>>,
  TError,
  { idIstanzaProcedimento: string; data: SubentroDTO },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackProcedimentiPraticaIdSubentro>>,
    { idIstanzaProcedimento: string; data: SubentroDTO }
  > = props => {
    const { idIstanzaProcedimento, data } = props ?? {};

    return postBackProcedimentiPraticaIdSubentro(
      idIstanzaProcedimento,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackProcedimentiPraticaIdSubentroMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackProcedimentiPraticaIdSubentro>>
>;
export type PostBackProcedimentiPraticaIdSubentroMutationBody = SubentroDTO;
export type PostBackProcedimentiPraticaIdSubentroMutationError =
  ErrorType<unknown>;

export const usePostBackProcedimentiPraticaIdSubentro = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackProcedimentiPraticaIdSubentro>>,
    TError,
    { idIstanzaProcedimento: string; data: SubentroDTO },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackProcedimentiPraticaIdSubentroMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackProcedimentiGeneraFileEstrazioneId = (
  idEstrazione: string,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<void>(
    {
      url: `/framework-bo-procedimenti/procedimenti/genera-file-estrazione/${idEstrazione}`,
      method: 'post',
    },
    options,
  );
};

export const getPostBackProcedimentiGeneraFileEstrazioneIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackProcedimentiGeneraFileEstrazioneId>>,
    TError,
    { idEstrazione: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackProcedimentiGeneraFileEstrazioneId>>,
  TError,
  { idEstrazione: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackProcedimentiGeneraFileEstrazioneId>>,
    { idEstrazione: string }
  > = props => {
    const { idEstrazione } = props ?? {};

    return postBackProcedimentiGeneraFileEstrazioneId(
      idEstrazione,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackProcedimentiGeneraFileEstrazioneIdMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postBackProcedimentiGeneraFileEstrazioneId>>
  >;

export type PostBackProcedimentiGeneraFileEstrazioneIdMutationError =
  ErrorType<unknown>;

export const usePostBackProcedimentiGeneraFileEstrazioneId = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackProcedimentiGeneraFileEstrazioneId>>,
    TError,
    { idEstrazione: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackProcedimentiGeneraFileEstrazioneIdMutationOptions(options);

  return useMutation(mutationOptions);
};
export const getBackProcedimentiB2B = (
  params: GetBackProcedimentiB2BParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<IstanzaProcedimento[]>(
    {
      url: `/framework-bo-procedimenti/procedimenti/b2b`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiB2BQueryKey = (
  params: GetBackProcedimentiB2BParams,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/b2b`,
    ...(params ? [params] : []),
  ] as const;

export const getGetBackProcedimentiB2BQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiB2B>>,
  TError = ErrorType<unknown>,
>(
  params: GetBackProcedimentiB2BParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiB2B>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiB2B>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBackProcedimentiB2BQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiB2B>>
  > = ({ signal }) => getBackProcedimentiB2B(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetBackProcedimentiB2BQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimentiB2B>>
>;
export type GetBackProcedimentiB2BQueryError = ErrorType<unknown>;

export const useGetBackProcedimentiB2B = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiB2B>>,
  TError = ErrorType<unknown>,
>(
  params: GetBackProcedimentiB2BParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiB2B>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackProcedimentiB2BQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postBackProcedimentiB2B = (
  postBackProcedimentiB2BBody: string[],
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<IstanzaProcedimento[]>(
    {
      url: `/framework-bo-procedimenti/procedimenti/b2b`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: postBackProcedimentiB2BBody,
    },
    options,
  );
};

export const getPostBackProcedimentiB2BMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackProcedimentiB2B>>,
    TError,
    { data: string[] },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackProcedimentiB2B>>,
  TError,
  { data: string[] },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackProcedimentiB2B>>,
    { data: string[] }
  > = props => {
    const { data } = props ?? {};

    return postBackProcedimentiB2B(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackProcedimentiB2BMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackProcedimentiB2B>>
>;
export type PostBackProcedimentiB2BMutationBody = string[];
export type PostBackProcedimentiB2BMutationError = ErrorType<unknown>;

export const usePostBackProcedimentiB2B = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackProcedimentiB2B>>,
    TError,
    { data: string[] },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getPostBackProcedimentiB2BMutationOptions(options);

  return useMutation(mutationOptions);
};
export const getBackProcedimenti = (
  params?: GetBackProcedimentiParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<BEResponseRicercaProcedimentoResponseDTO>(
    {
      url: `/framework-bo-procedimenti/procedimenti`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiQueryKey = (
  params?: GetBackProcedimentiParams,
) =>
  [
    `/framework-bo-procedimenti/procedimenti`,
    ...(params ? [params] : []),
  ] as const;

export const getGetBackProcedimentiQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackProcedimenti>>,
  TError = ErrorType<unknown>,
>(
  params?: GetBackProcedimentiParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimenti>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimenti>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBackProcedimentiQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimenti>>
  > = ({ signal }) => getBackProcedimenti(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetBackProcedimentiQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimenti>>
>;
export type GetBackProcedimentiQueryError = ErrorType<unknown>;

export const useGetBackProcedimenti = <
  TData = Awaited<ReturnType<typeof getBackProcedimenti>>,
  TError = ErrorType<unknown>,
>(
  params?: GetBackProcedimentiParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimenti>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackProcedimentiQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getBackProcedimentiIdIsDeletable = (
  idTagSemantico: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<boolean>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idTagSemantico}/isDeletable`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiIdIsDeletableQueryKey = (
  idTagSemantico: string,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/${idTagSemantico}/isDeletable`,
  ] as const;

export const getGetBackProcedimentiIdIsDeletableQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdIsDeletable>>,
  TError = ErrorType<unknown>,
>(
  idTagSemantico: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdIsDeletable>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiIdIsDeletable>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackProcedimentiIdIsDeletableQueryKey(idTagSemantico);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiIdIsDeletable>>
  > = ({ signal }) =>
    getBackProcedimentiIdIsDeletable(idTagSemantico, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!idTagSemantico, ...queryOptions };
};

export type GetBackProcedimentiIdIsDeletableQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimentiIdIsDeletable>>
>;
export type GetBackProcedimentiIdIsDeletableQueryError = ErrorType<unknown>;

export const useGetBackProcedimentiIdIsDeletable = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdIsDeletable>>,
  TError = ErrorType<unknown>,
>(
  idTagSemantico: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdIsDeletable>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackProcedimentiIdIsDeletableQueryOptions(
    idTagSemantico,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Scaricare tutti i documenti associati ad un procedimento in un archivio compresso organizzato in cartelle per tipologia di documento
 * @summary Scaricare tutti i documenti associati ad un procedimento in un archivio compresso organizzato in cartelle per tipologia di documento
 */
export const getBackProcedimentiIdZip = (
  idIstanzaProcedimento: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<string[]>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/zip`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiIdZipQueryKey = (
  idIstanzaProcedimento: string,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/zip`,
  ] as const;

export const getGetBackProcedimentiIdZipQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdZip>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdZip>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiIdZip>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackProcedimentiIdZipQueryKey(idIstanzaProcedimento);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiIdZip>>
  > = ({ signal }) =>
    getBackProcedimentiIdZip(idIstanzaProcedimento, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!idIstanzaProcedimento,
    ...queryOptions,
  };
};

export type GetBackProcedimentiIdZipQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimentiIdZip>>
>;
export type GetBackProcedimentiIdZipQueryError = ErrorType<unknown>;

/**
 * @summary Scaricare tutti i documenti associati ad un procedimento in un archivio compresso organizzato in cartelle per tipologia di documento
 */
export const useGetBackProcedimentiIdZip = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdZip>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdZip>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackProcedimentiIdZipQueryOptions(
    idIstanzaProcedimento,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getBackProcedimentiIdTipiOggettiCollegati = (
  idIstanzaProcedimento: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<OggettiCollegatiResponse>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/tipi-oggetti-collegati`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiIdTipiOggettiCollegatiQueryKey = (
  idIstanzaProcedimento: string,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/tipi-oggetti-collegati`,
  ] as const;

export const getGetBackProcedimentiIdTipiOggettiCollegatiQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdTipiOggettiCollegati>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdTipiOggettiCollegati>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiIdTipiOggettiCollegati>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackProcedimentiIdTipiOggettiCollegatiQueryKey(idIstanzaProcedimento);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiIdTipiOggettiCollegati>>
  > = ({ signal }) =>
    getBackProcedimentiIdTipiOggettiCollegati(
      idIstanzaProcedimento,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!idIstanzaProcedimento,
    ...queryOptions,
  };
};

export type GetBackProcedimentiIdTipiOggettiCollegatiQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimentiIdTipiOggettiCollegati>>
>;
export type GetBackProcedimentiIdTipiOggettiCollegatiQueryError =
  ErrorType<unknown>;

export const useGetBackProcedimentiIdTipiOggettiCollegati = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdTipiOggettiCollegati>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdTipiOggettiCollegati>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackProcedimentiIdTipiOggettiCollegatiQueryOptions(
    idIstanzaProcedimento,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getBackProcedimentiIdTipiDomanda = (
  idIstanzaProcedimento: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<PraticaDomandaDTO[]>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/tipi-domanda`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiIdTipiDomandaQueryKey = (
  idIstanzaProcedimento: string,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/tipi-domanda`,
  ] as const;

export const getGetBackProcedimentiIdTipiDomandaQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdTipiDomanda>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdTipiDomanda>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiIdTipiDomanda>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackProcedimentiIdTipiDomandaQueryKey(idIstanzaProcedimento);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiIdTipiDomanda>>
  > = ({ signal }) =>
    getBackProcedimentiIdTipiDomanda(
      idIstanzaProcedimento,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!idIstanzaProcedimento,
    ...queryOptions,
  };
};

export type GetBackProcedimentiIdTipiDomandaQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimentiIdTipiDomanda>>
>;
export type GetBackProcedimentiIdTipiDomandaQueryError = ErrorType<unknown>;

export const useGetBackProcedimentiIdTipiDomanda = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdTipiDomanda>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdTipiDomanda>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackProcedimentiIdTipiDomandaQueryOptions(
    idIstanzaProcedimento,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Ricerca tipi comunicazione di un tipo procedimento. Ordinabile per codice tipo comunicazione se a true il campo ordinaPerCodice in requestParam
 * @summary Ricerca tipi comunicazione di un tipo procedimento
 */
export const getBackProcedimentiIdTipiComunicazione = (
  idIstanzaProcedimento: string,
  params?: GetBackProcedimentiIdTipiComunicazioneParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<TipoComunicazioneDTO[]>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/tipi-comunicazione`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiIdTipiComunicazioneQueryKey = (
  idIstanzaProcedimento: string,
  params?: GetBackProcedimentiIdTipiComunicazioneParams,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/tipi-comunicazione`,
    ...(params ? [params] : []),
  ] as const;

export const getGetBackProcedimentiIdTipiComunicazioneQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdTipiComunicazione>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  params?: GetBackProcedimentiIdTipiComunicazioneParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdTipiComunicazione>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiIdTipiComunicazione>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackProcedimentiIdTipiComunicazioneQueryKey(
      idIstanzaProcedimento,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiIdTipiComunicazione>>
  > = ({ signal }) =>
    getBackProcedimentiIdTipiComunicazione(
      idIstanzaProcedimento,
      params,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!idIstanzaProcedimento,
    ...queryOptions,
  };
};

export type GetBackProcedimentiIdTipiComunicazioneQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimentiIdTipiComunicazione>>
>;
export type GetBackProcedimentiIdTipiComunicazioneQueryError =
  ErrorType<unknown>;

/**
 * @summary Ricerca tipi comunicazione di un tipo procedimento
 */
export const useGetBackProcedimentiIdTipiComunicazione = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdTipiComunicazione>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  params?: GetBackProcedimentiIdTipiComunicazioneParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdTipiComunicazione>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackProcedimentiIdTipiComunicazioneQueryOptions(
    idIstanzaProcedimento,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getBackProcedimentiIdScadenzeId = (
  idIstanzaProcedimento: string,
  idScadenza: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<ScadenzaDTO>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/scadenze/${idScadenza}`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiIdScadenzeIdQueryKey = (
  idIstanzaProcedimento: string,
  idScadenza: string,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/scadenze/${idScadenza}`,
  ] as const;

export const getGetBackProcedimentiIdScadenzeIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdScadenzeId>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  idScadenza: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdScadenzeId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiIdScadenzeId>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackProcedimentiIdScadenzeIdQueryKey(
      idIstanzaProcedimento,
      idScadenza,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiIdScadenzeId>>
  > = ({ signal }) =>
    getBackProcedimentiIdScadenzeId(
      idIstanzaProcedimento,
      idScadenza,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(idIstanzaProcedimento && idScadenza),
    ...queryOptions,
  };
};

export type GetBackProcedimentiIdScadenzeIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimentiIdScadenzeId>>
>;
export type GetBackProcedimentiIdScadenzeIdQueryError = ErrorType<unknown>;

export const useGetBackProcedimentiIdScadenzeId = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdScadenzeId>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  idScadenza: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdScadenzeId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackProcedimentiIdScadenzeIdQueryOptions(
    idIstanzaProcedimento,
    idScadenza,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const deleteBackProcedimentiIdScadenzeId = (
  idIstanzaProcedimento: string,
  idScadenza: string,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<ScadenzaDTO>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/scadenze/${idScadenza}`,
      method: 'delete',
    },
    options,
  );
};

export const getDeleteBackProcedimentiIdScadenzeIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteBackProcedimentiIdScadenzeId>>,
    TError,
    { idIstanzaProcedimento: string; idScadenza: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteBackProcedimentiIdScadenzeId>>,
  TError,
  { idIstanzaProcedimento: string; idScadenza: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteBackProcedimentiIdScadenzeId>>,
    { idIstanzaProcedimento: string; idScadenza: string }
  > = props => {
    const { idIstanzaProcedimento, idScadenza } = props ?? {};

    return deleteBackProcedimentiIdScadenzeId(
      idIstanzaProcedimento,
      idScadenza,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteBackProcedimentiIdScadenzeIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteBackProcedimentiIdScadenzeId>>
>;

export type DeleteBackProcedimentiIdScadenzeIdMutationError =
  ErrorType<unknown>;

export const useDeleteBackProcedimentiIdScadenzeId = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteBackProcedimentiIdScadenzeId>>,
    TError,
    { idIstanzaProcedimento: string; idScadenza: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getDeleteBackProcedimentiIdScadenzeIdMutationOptions(options);

  return useMutation(mutationOptions);
};
export const getBackProcedimentiIdOggettiCollegati = (
  idIstanzaProcedimento: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<BEResponseProcedimentoConOggettiCollegati>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/oggettiCollegati`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiIdOggettiCollegatiQueryKey = (
  idIstanzaProcedimento: string,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/oggettiCollegati`,
  ] as const;

export const getGetBackProcedimentiIdOggettiCollegatiQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdOggettiCollegati>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdOggettiCollegati>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiIdOggettiCollegati>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackProcedimentiIdOggettiCollegatiQueryKey(idIstanzaProcedimento);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiIdOggettiCollegati>>
  > = ({ signal }) =>
    getBackProcedimentiIdOggettiCollegati(
      idIstanzaProcedimento,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!idIstanzaProcedimento,
    ...queryOptions,
  };
};

export type GetBackProcedimentiIdOggettiCollegatiQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimentiIdOggettiCollegati>>
>;
export type GetBackProcedimentiIdOggettiCollegatiQueryError =
  ErrorType<unknown>;

export const useGetBackProcedimentiIdOggettiCollegati = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdOggettiCollegati>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdOggettiCollegati>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackProcedimentiIdOggettiCollegatiQueryOptions(
    idIstanzaProcedimento,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Esegue il download della versione PDF della sezione dati di una istanza tipo pagamento associata ad un procedimento
 * @summary download pdf del preventivo
 */
export const getBackProcedimentiIdIstanzeTipiPagamentoIdScaricaPreventivo = (
  idIstanzaProcedimento: string,
  idIstanzaTipoPagamento: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<string[]>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/istanze-tipi-pagamento/${idIstanzaTipoPagamento}/scarica-preventivo`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiIdIstanzeTipiPagamentoIdScaricaPreventivoQueryKey =
  (idIstanzaProcedimento: string, idIstanzaTipoPagamento: string) =>
    [
      `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/istanze-tipi-pagamento/${idIstanzaTipoPagamento}/scarica-preventivo`,
    ] as const;

export const getGetBackProcedimentiIdIstanzeTipiPagamentoIdScaricaPreventivoQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getBackProcedimentiIdIstanzeTipiPagamentoIdScaricaPreventivo
      >
    >,
    TError = ErrorType<unknown>,
  >(
    idIstanzaProcedimento: string,
    idIstanzaTipoPagamento: string,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getBackProcedimentiIdIstanzeTipiPagamentoIdScaricaPreventivo
          >
        >,
        TError,
        TData
      >;
      request?: SecondParameter<typeof apiClientRequest>;
    },
  ): UseQueryOptions<
    Awaited<
      ReturnType<
        typeof getBackProcedimentiIdIstanzeTipiPagamentoIdScaricaPreventivo
      >
    >,
    TError,
    TData
  > & { queryKey: QueryKey } => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetBackProcedimentiIdIstanzeTipiPagamentoIdScaricaPreventivoQueryKey(
        idIstanzaProcedimento,
        idIstanzaTipoPagamento,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getBackProcedimentiIdIstanzeTipiPagamentoIdScaricaPreventivo
        >
      >
    > = ({ signal }) =>
      getBackProcedimentiIdIstanzeTipiPagamentoIdScaricaPreventivo(
        idIstanzaProcedimento,
        idIstanzaTipoPagamento,
        requestOptions,
        signal,
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(idIstanzaProcedimento && idIstanzaTipoPagamento),
      ...queryOptions,
    };
  };

export type GetBackProcedimentiIdIstanzeTipiPagamentoIdScaricaPreventivoQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getBackProcedimentiIdIstanzeTipiPagamentoIdScaricaPreventivo
      >
    >
  >;
export type GetBackProcedimentiIdIstanzeTipiPagamentoIdScaricaPreventivoQueryError =
  ErrorType<unknown>;

/**
 * @summary download pdf del preventivo
 */
export const useGetBackProcedimentiIdIstanzeTipiPagamentoIdScaricaPreventivo = <
  TData = Awaited<
    ReturnType<
      typeof getBackProcedimentiIdIstanzeTipiPagamentoIdScaricaPreventivo
    >
  >,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  idIstanzaTipoPagamento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getBackProcedimentiIdIstanzeTipiPagamentoIdScaricaPreventivo
        >
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetBackProcedimentiIdIstanzeTipiPagamentoIdScaricaPreventivoQueryOptions(
      idIstanzaProcedimento,
      idIstanzaTipoPagamento,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getBackProcedimentiIdInfoGenerali = (
  idIstanzaProcedimento: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<BEResponseProcedimentoConTask>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/infoGenerali`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiIdInfoGeneraliQueryKey = (
  idIstanzaProcedimento: string,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/infoGenerali`,
  ] as const;

export const getGetBackProcedimentiIdInfoGeneraliQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdInfoGenerali>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdInfoGenerali>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiIdInfoGenerali>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackProcedimentiIdInfoGeneraliQueryKey(idIstanzaProcedimento);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiIdInfoGenerali>>
  > = ({ signal }) =>
    getBackProcedimentiIdInfoGenerali(
      idIstanzaProcedimento,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!idIstanzaProcedimento,
    ...queryOptions,
  };
};

export type GetBackProcedimentiIdInfoGeneraliQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimentiIdInfoGenerali>>
>;
export type GetBackProcedimentiIdInfoGeneraliQueryError = ErrorType<unknown>;

export const useGetBackProcedimentiIdInfoGenerali = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdInfoGenerali>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdInfoGenerali>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackProcedimentiIdInfoGeneraliQueryOptions(
    idIstanzaProcedimento,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getBackProcedimentiIdFile = (
  idIstanzaProcedimento: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<ElencoFileDocumento[]>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/file`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiIdFileQueryKey = (
  idIstanzaProcedimento: string,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/file`,
  ] as const;

export const getGetBackProcedimentiIdFileQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdFile>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdFile>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiIdFile>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackProcedimentiIdFileQueryKey(idIstanzaProcedimento);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiIdFile>>
  > = ({ signal }) =>
    getBackProcedimentiIdFile(idIstanzaProcedimento, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!idIstanzaProcedimento,
    ...queryOptions,
  };
};

export type GetBackProcedimentiIdFileQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimentiIdFile>>
>;
export type GetBackProcedimentiIdFileQueryError = ErrorType<unknown>;

export const useGetBackProcedimentiIdFile = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdFile>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdFile>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackProcedimentiIdFileQueryOptions(
    idIstanzaProcedimento,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getBackProcedimentiIdFileDocumentoId = (
  idIstanzaProcedimento: string,
  idFile: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<string[]>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/fileDocumento/${idFile}`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiIdFileDocumentoIdQueryKey = (
  idIstanzaProcedimento: string,
  idFile: string,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/fileDocumento/${idFile}`,
  ] as const;

export const getGetBackProcedimentiIdFileDocumentoIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdFileDocumentoId>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  idFile: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdFileDocumentoId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiIdFileDocumentoId>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackProcedimentiIdFileDocumentoIdQueryKey(
      idIstanzaProcedimento,
      idFile,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiIdFileDocumentoId>>
  > = ({ signal }) =>
    getBackProcedimentiIdFileDocumentoId(
      idIstanzaProcedimento,
      idFile,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(idIstanzaProcedimento && idFile),
    ...queryOptions,
  };
};

export type GetBackProcedimentiIdFileDocumentoIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimentiIdFileDocumentoId>>
>;
export type GetBackProcedimentiIdFileDocumentoIdQueryError = ErrorType<unknown>;

export const useGetBackProcedimentiIdFileDocumentoId = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdFileDocumentoId>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  idFile: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdFileDocumentoId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackProcedimentiIdFileDocumentoIdQueryOptions(
    idIstanzaProcedimento,
    idFile,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getBackProcedimentiIdFileAllegatoId = (
  idIstanzaProcedimento: string,
  idFile: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<string[]>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/fileAllegato/${idFile}`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiIdFileAllegatoIdQueryKey = (
  idIstanzaProcedimento: string,
  idFile: string,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/fileAllegato/${idFile}`,
  ] as const;

export const getGetBackProcedimentiIdFileAllegatoIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdFileAllegatoId>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  idFile: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdFileAllegatoId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiIdFileAllegatoId>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackProcedimentiIdFileAllegatoIdQueryKey(
      idIstanzaProcedimento,
      idFile,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiIdFileAllegatoId>>
  > = ({ signal }) =>
    getBackProcedimentiIdFileAllegatoId(
      idIstanzaProcedimento,
      idFile,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(idIstanzaProcedimento && idFile),
    ...queryOptions,
  };
};

export type GetBackProcedimentiIdFileAllegatoIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimentiIdFileAllegatoId>>
>;
export type GetBackProcedimentiIdFileAllegatoIdQueryError = ErrorType<unknown>;

export const useGetBackProcedimentiIdFileAllegatoId = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdFileAllegatoId>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  idFile: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdFileAllegatoId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackProcedimentiIdFileAllegatoIdQueryOptions(
    idIstanzaProcedimento,
    idFile,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getBackProcedimentiIdEndoprocedimenti = (
  idIstanzaProcedimento: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<BEResponseListProcedimento>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/endoprocedimenti`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiIdEndoprocedimentiQueryKey = (
  idIstanzaProcedimento: string,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/endoprocedimenti`,
  ] as const;

export const getGetBackProcedimentiIdEndoprocedimentiQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdEndoprocedimenti>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdEndoprocedimenti>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiIdEndoprocedimenti>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackProcedimentiIdEndoprocedimentiQueryKey(idIstanzaProcedimento);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiIdEndoprocedimenti>>
  > = ({ signal }) =>
    getBackProcedimentiIdEndoprocedimenti(
      idIstanzaProcedimento,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!idIstanzaProcedimento,
    ...queryOptions,
  };
};

export type GetBackProcedimentiIdEndoprocedimentiQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimentiIdEndoprocedimenti>>
>;
export type GetBackProcedimentiIdEndoprocedimentiQueryError =
  ErrorType<unknown>;

export const useGetBackProcedimentiIdEndoprocedimenti = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdEndoprocedimenti>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdEndoprocedimenti>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackProcedimentiIdEndoprocedimentiQueryOptions(
    idIstanzaProcedimento,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getBackProcedimentiIdEndoprocedimentiPrimoLivello = (
  idIstanzaProcedimento: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<string[]>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/endoprocedimenti-primo-livello`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiIdEndoprocedimentiPrimoLivelloQueryKey = (
  idIstanzaProcedimento: string,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/endoprocedimenti-primo-livello`,
  ] as const;

export const getGetBackProcedimentiIdEndoprocedimentiPrimoLivelloQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getBackProcedimentiIdEndoprocedimentiPrimoLivello>
    >,
    TError = ErrorType<unknown>,
  >(
    idIstanzaProcedimento: string,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<typeof getBackProcedimentiIdEndoprocedimentiPrimoLivello>
        >,
        TError,
        TData
      >;
      request?: SecondParameter<typeof apiClientRequest>;
    },
  ): UseQueryOptions<
    Awaited<
      ReturnType<typeof getBackProcedimentiIdEndoprocedimentiPrimoLivello>
    >,
    TError,
    TData
  > & { queryKey: QueryKey } => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetBackProcedimentiIdEndoprocedimentiPrimoLivelloQueryKey(
        idIstanzaProcedimento,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getBackProcedimentiIdEndoprocedimentiPrimoLivello>
      >
    > = ({ signal }) =>
      getBackProcedimentiIdEndoprocedimentiPrimoLivello(
        idIstanzaProcedimento,
        requestOptions,
        signal,
      );

    return {
      queryKey,
      queryFn,
      enabled: !!idIstanzaProcedimento,
      ...queryOptions,
    };
  };

export type GetBackProcedimentiIdEndoprocedimentiPrimoLivelloQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getBackProcedimentiIdEndoprocedimentiPrimoLivello>
    >
  >;
export type GetBackProcedimentiIdEndoprocedimentiPrimoLivelloQueryError =
  ErrorType<unknown>;

export const useGetBackProcedimentiIdEndoprocedimentiPrimoLivello = <
  TData = Awaited<
    ReturnType<typeof getBackProcedimentiIdEndoprocedimentiPrimoLivello>
  >,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof getBackProcedimentiIdEndoprocedimentiPrimoLivello>
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetBackProcedimentiIdEndoprocedimentiPrimoLivelloQueryOptions(
      idIstanzaProcedimento,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Ricerca paginata filtrate per idProcedimento delle Comunicazioni. E' ordinabile per idTipoComunicazione
 * @summary Ricerca paginata filtrate per idProcedimento delle Comunicazioni
 */
export const getBackProcedimentiIdComunicazioni = (
  idIstanzaProcedimento: string,
  params?: GetBackProcedimentiIdComunicazioniParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<WsRispostaPaginataListComunicazioneDTO>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/comunicazioni`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiIdComunicazioniQueryKey = (
  idIstanzaProcedimento: string,
  params?: GetBackProcedimentiIdComunicazioniParams,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/comunicazioni`,
    ...(params ? [params] : []),
  ] as const;

export const getGetBackProcedimentiIdComunicazioniQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdComunicazioni>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  params?: GetBackProcedimentiIdComunicazioniParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdComunicazioni>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiIdComunicazioni>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackProcedimentiIdComunicazioniQueryKey(
      idIstanzaProcedimento,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiIdComunicazioni>>
  > = ({ signal }) =>
    getBackProcedimentiIdComunicazioni(
      idIstanzaProcedimento,
      params,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!idIstanzaProcedimento,
    ...queryOptions,
  };
};

export type GetBackProcedimentiIdComunicazioniQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimentiIdComunicazioni>>
>;
export type GetBackProcedimentiIdComunicazioniQueryError = ErrorType<unknown>;

/**
 * @summary Ricerca paginata filtrate per idProcedimento delle Comunicazioni
 */
export const useGetBackProcedimentiIdComunicazioni = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdComunicazioni>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  params?: GetBackProcedimentiIdComunicazioniParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdComunicazioni>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackProcedimentiIdComunicazioniQueryOptions(
    idIstanzaProcedimento,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Ricerca puntuale Comunicazione
 * @summary Ricerca puntuale Comunicazione
 */
export const getBackProcedimentiIdComunicazioniId = (
  idIstanzaProcedimento: string,
  idComunicazione: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<ComunicazioneDTO>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/comunicazioni/${idComunicazione}`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiIdComunicazioniIdQueryKey = (
  idIstanzaProcedimento: string,
  idComunicazione: string,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/comunicazioni/${idComunicazione}`,
  ] as const;

export const getGetBackProcedimentiIdComunicazioniIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdComunicazioniId>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  idComunicazione: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdComunicazioniId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiIdComunicazioniId>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackProcedimentiIdComunicazioniIdQueryKey(
      idIstanzaProcedimento,
      idComunicazione,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiIdComunicazioniId>>
  > = ({ signal }) =>
    getBackProcedimentiIdComunicazioniId(
      idIstanzaProcedimento,
      idComunicazione,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(idIstanzaProcedimento && idComunicazione),
    ...queryOptions,
  };
};

export type GetBackProcedimentiIdComunicazioniIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimentiIdComunicazioniId>>
>;
export type GetBackProcedimentiIdComunicazioniIdQueryError = ErrorType<unknown>;

/**
 * @summary Ricerca puntuale Comunicazione
 */
export const useGetBackProcedimentiIdComunicazioniId = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdComunicazioniId>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  idComunicazione: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdComunicazioniId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackProcedimentiIdComunicazioniIdQueryOptions(
    idIstanzaProcedimento,
    idComunicazione,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Ricerca puntuale Allegato comunicazione
 * @summary Ricerca puntuale Allegato comunicazione
 */
export const getBackProcedimentiIdComunicazioniAllegatiId = (
  idIstanzaProcedimento: string,
  idAllegato: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<string[]>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/comunicazioni/allegati/${idAllegato}`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiIdComunicazioniAllegatiIdQueryKey = (
  idIstanzaProcedimento: string,
  idAllegato: string,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/comunicazioni/allegati/${idAllegato}`,
  ] as const;

export const getGetBackProcedimentiIdComunicazioniAllegatiIdQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getBackProcedimentiIdComunicazioniAllegatiId>
  >,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  idAllegato: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdComunicazioniAllegatiId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiIdComunicazioniAllegatiId>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackProcedimentiIdComunicazioniAllegatiIdQueryKey(
      idIstanzaProcedimento,
      idAllegato,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiIdComunicazioniAllegatiId>>
  > = ({ signal }) =>
    getBackProcedimentiIdComunicazioniAllegatiId(
      idIstanzaProcedimento,
      idAllegato,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(idIstanzaProcedimento && idAllegato),
    ...queryOptions,
  };
};

export type GetBackProcedimentiIdComunicazioniAllegatiIdQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getBackProcedimentiIdComunicazioniAllegatiId>>
  >;
export type GetBackProcedimentiIdComunicazioniAllegatiIdQueryError =
  ErrorType<unknown>;

/**
 * @summary Ricerca puntuale Allegato comunicazione
 */
export const useGetBackProcedimentiIdComunicazioniAllegatiId = <
  TData = Awaited<
    ReturnType<typeof getBackProcedimentiIdComunicazioniAllegatiId>
  >,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  idAllegato: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdComunicazioniAllegatiId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetBackProcedimentiIdComunicazioniAllegatiIdQueryOptions(
      idIstanzaProcedimento,
      idAllegato,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getBackProcedimentiIdCollegamenti = (
  idIstanzaProcedimento: string,
  params?: GetBackProcedimentiIdCollegamentiParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<BEResponseWsRispostaPaginataListCollegamentoIstanzaDettaglioDTO>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/collegamenti`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiIdCollegamentiQueryKey = (
  idIstanzaProcedimento: string,
  params?: GetBackProcedimentiIdCollegamentiParams,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/collegamenti`,
    ...(params ? [params] : []),
  ] as const;

export const getGetBackProcedimentiIdCollegamentiQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdCollegamenti>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  params?: GetBackProcedimentiIdCollegamentiParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdCollegamenti>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiIdCollegamenti>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackProcedimentiIdCollegamentiQueryKey(idIstanzaProcedimento, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiIdCollegamenti>>
  > = ({ signal }) =>
    getBackProcedimentiIdCollegamenti(
      idIstanzaProcedimento,
      params,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!idIstanzaProcedimento,
    ...queryOptions,
  };
};

export type GetBackProcedimentiIdCollegamentiQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimentiIdCollegamenti>>
>;
export type GetBackProcedimentiIdCollegamentiQueryError = ErrorType<unknown>;

export const useGetBackProcedimentiIdCollegamenti = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdCollegamenti>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  params?: GetBackProcedimentiIdCollegamentiParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdCollegamenti>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackProcedimentiIdCollegamentiQueryOptions(
    idIstanzaProcedimento,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Restituisce gli uffici selezionabili per l'avvio di endoprocedimenti
 * @summary Restituisce gli uffici per avvio endoprocedimento
 */
export const getBackProcedimentiIdTipiEndoprocedimentoIdUffici = (
  idIstanzaProcedimentoPadre: string,
  idTipoEndoprocedimento: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<TipoProcedimentoDettaglioUfficiAssociatiDTO>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimentoPadre}/tipi-endoprocedimento/${idTipoEndoprocedimento}/uffici`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiIdTipiEndoprocedimentoIdUfficiQueryKey = (
  idIstanzaProcedimentoPadre: string,
  idTipoEndoprocedimento: string,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimentoPadre}/tipi-endoprocedimento/${idTipoEndoprocedimento}/uffici`,
  ] as const;

export const getGetBackProcedimentiIdTipiEndoprocedimentoIdUfficiQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getBackProcedimentiIdTipiEndoprocedimentoIdUffici>
    >,
    TError = ErrorType<unknown>,
  >(
    idIstanzaProcedimentoPadre: string,
    idTipoEndoprocedimento: string,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<typeof getBackProcedimentiIdTipiEndoprocedimentoIdUffici>
        >,
        TError,
        TData
      >;
      request?: SecondParameter<typeof apiClientRequest>;
    },
  ): UseQueryOptions<
    Awaited<
      ReturnType<typeof getBackProcedimentiIdTipiEndoprocedimentoIdUffici>
    >,
    TError,
    TData
  > & { queryKey: QueryKey } => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetBackProcedimentiIdTipiEndoprocedimentoIdUfficiQueryKey(
        idIstanzaProcedimentoPadre,
        idTipoEndoprocedimento,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getBackProcedimentiIdTipiEndoprocedimentoIdUffici>
      >
    > = ({ signal }) =>
      getBackProcedimentiIdTipiEndoprocedimentoIdUffici(
        idIstanzaProcedimentoPadre,
        idTipoEndoprocedimento,
        requestOptions,
        signal,
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(idIstanzaProcedimentoPadre && idTipoEndoprocedimento),
      ...queryOptions,
    };
  };

export type GetBackProcedimentiIdTipiEndoprocedimentoIdUfficiQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getBackProcedimentiIdTipiEndoprocedimentoIdUffici>
    >
  >;
export type GetBackProcedimentiIdTipiEndoprocedimentoIdUfficiQueryError =
  ErrorType<unknown>;

/**
 * @summary Restituisce gli uffici per avvio endoprocedimento
 */
export const useGetBackProcedimentiIdTipiEndoprocedimentoIdUffici = <
  TData = Awaited<
    ReturnType<typeof getBackProcedimentiIdTipiEndoprocedimentoIdUffici>
  >,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimentoPadre: string,
  idTipoEndoprocedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof getBackProcedimentiIdTipiEndoprocedimentoIdUffici>
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetBackProcedimentiIdTipiEndoprocedimentoIdUfficiQueryOptions(
      idIstanzaProcedimentoPadre,
      idTipoEndoprocedimento,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getBackProcedimentiXlsx = (
  params?: GetBackProcedimentiXlsxParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<string[]>(
    {
      url: `/framework-bo-procedimenti/procedimenti/xlsx`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiXlsxQueryKey = (
  params?: GetBackProcedimentiXlsxParams,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/xlsx`,
    ...(params ? [params] : []),
  ] as const;

export const getGetBackProcedimentiXlsxQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiXlsx>>,
  TError = ErrorType<unknown>,
>(
  params?: GetBackProcedimentiXlsxParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiXlsx>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiXlsx>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBackProcedimentiXlsxQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiXlsx>>
  > = ({ signal }) => getBackProcedimentiXlsx(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetBackProcedimentiXlsxQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimentiXlsx>>
>;
export type GetBackProcedimentiXlsxQueryError = ErrorType<unknown>;

export const useGetBackProcedimentiXlsx = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiXlsx>>,
  TError = ErrorType<unknown>,
>(
  params?: GetBackProcedimentiXlsxParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiXlsx>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackProcedimentiXlsxQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getBackProcedimentiTipi = (
  params?: GetBackProcedimentiTipiParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<BEResponseListTipologiaProcedimentoDTO>(
    {
      url: `/framework-bo-procedimenti/procedimenti/tipi`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiTipiQueryKey = (
  params?: GetBackProcedimentiTipiParams,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/tipi`,
    ...(params ? [params] : []),
  ] as const;

export const getGetBackProcedimentiTipiQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiTipi>>,
  TError = ErrorType<unknown>,
>(
  params?: GetBackProcedimentiTipiParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiTipi>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiTipi>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBackProcedimentiTipiQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiTipi>>
  > = ({ signal }) => getBackProcedimentiTipi(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetBackProcedimentiTipiQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimentiTipi>>
>;
export type GetBackProcedimentiTipiQueryError = ErrorType<unknown>;

export const useGetBackProcedimentiTipi = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiTipi>>,
  TError = ErrorType<unknown>,
>(
  params?: GetBackProcedimentiTipiParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiTipi>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackProcedimentiTipiQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getBackProcedimentiTipiAvviabili = (
  params?: GetBackProcedimentiTipiAvviabiliParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<BEResponseListTipologiaProcedimentoDTO>(
    {
      url: `/framework-bo-procedimenti/procedimenti/tipiAvviabili`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiTipiAvviabiliQueryKey = (
  params?: GetBackProcedimentiTipiAvviabiliParams,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/tipiAvviabili`,
    ...(params ? [params] : []),
  ] as const;

export const getGetBackProcedimentiTipiAvviabiliQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiTipiAvviabili>>,
  TError = ErrorType<unknown>,
>(
  params?: GetBackProcedimentiTipiAvviabiliParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiTipiAvviabili>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiTipiAvviabili>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackProcedimentiTipiAvviabiliQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiTipiAvviabili>>
  > = ({ signal }) =>
    getBackProcedimentiTipiAvviabili(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetBackProcedimentiTipiAvviabiliQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimentiTipiAvviabili>>
>;
export type GetBackProcedimentiTipiAvviabiliQueryError = ErrorType<unknown>;

export const useGetBackProcedimentiTipiAvviabili = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiTipiAvviabili>>,
  TError = ErrorType<unknown>,
>(
  params?: GetBackProcedimentiTipiAvviabiliParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiTipiAvviabili>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackProcedimentiTipiAvviabiliQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getBackProcedimentiPraticaIdPersoneFisiche = (
  idIstanzaProcedimento: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<PersonaFisicaDTO[]>(
    {
      url: `/framework-bo-procedimenti/procedimenti/pratica/${idIstanzaProcedimento}/persone-fisiche`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiPraticaIdPersoneFisicheQueryKey = (
  idIstanzaProcedimento: string,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/pratica/${idIstanzaProcedimento}/persone-fisiche`,
  ] as const;

export const getGetBackProcedimentiPraticaIdPersoneFisicheQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getBackProcedimentiPraticaIdPersoneFisiche>
  >,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiPraticaIdPersoneFisiche>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiPraticaIdPersoneFisiche>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackProcedimentiPraticaIdPersoneFisicheQueryKey(
      idIstanzaProcedimento,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiPraticaIdPersoneFisiche>>
  > = ({ signal }) =>
    getBackProcedimentiPraticaIdPersoneFisiche(
      idIstanzaProcedimento,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!idIstanzaProcedimento,
    ...queryOptions,
  };
};

export type GetBackProcedimentiPraticaIdPersoneFisicheQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimentiPraticaIdPersoneFisiche>>
>;
export type GetBackProcedimentiPraticaIdPersoneFisicheQueryError =
  ErrorType<unknown>;

export const useGetBackProcedimentiPraticaIdPersoneFisiche = <
  TData = Awaited<
    ReturnType<typeof getBackProcedimentiPraticaIdPersoneFisiche>
  >,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiPraticaIdPersoneFisiche>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetBackProcedimentiPraticaIdPersoneFisicheQueryOptions(
      idIstanzaProcedimento,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getBackProcedimentiGeojson = (
  params?: GetBackProcedimentiGeojsonParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<GetBackProcedimentiGeojson200>(
    {
      url: `/framework-bo-procedimenti/procedimenti/geojson`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiGeojsonQueryKey = (
  params?: GetBackProcedimentiGeojsonParams,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/geojson`,
    ...(params ? [params] : []),
  ] as const;

export const getGetBackProcedimentiGeojsonQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiGeojson>>,
  TError = ErrorType<unknown>,
>(
  params?: GetBackProcedimentiGeojsonParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiGeojson>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiGeojson>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBackProcedimentiGeojsonQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiGeojson>>
  > = ({ signal }) =>
    getBackProcedimentiGeojson(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetBackProcedimentiGeojsonQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimentiGeojson>>
>;
export type GetBackProcedimentiGeojsonQueryError = ErrorType<unknown>;

export const useGetBackProcedimentiGeojson = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiGeojson>>,
  TError = ErrorType<unknown>,
>(
  params?: GetBackProcedimentiGeojsonParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiGeojson>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackProcedimentiGeojsonQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Recupero tutti i campi potenzialmente estraibili in csv per i procedimenti/versione procedimenti pubblicati (per verticale)
 */
export const getBackProcedimentiGeojsonCampi = (
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<CampoEstraibileCSV[]>(
    {
      url: `/framework-bo-procedimenti/procedimenti/geojson/campi`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiGeojsonCampiQueryKey = () =>
  [`/framework-bo-procedimenti/procedimenti/geojson/campi`] as const;

export const getGetBackProcedimentiGeojsonCampiQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiGeojsonCampi>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getBackProcedimentiGeojsonCampi>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiGeojsonCampi>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBackProcedimentiGeojsonCampiQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiGeojsonCampi>>
  > = ({ signal }) => getBackProcedimentiGeojsonCampi(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetBackProcedimentiGeojsonCampiQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimentiGeojsonCampi>>
>;
export type GetBackProcedimentiGeojsonCampiQueryError = ErrorType<unknown>;

export const useGetBackProcedimentiGeojsonCampi = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiGeojsonCampi>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getBackProcedimentiGeojsonCampi>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackProcedimentiGeojsonCampiQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getBackProcedimentiEstrazioneTipoEstrazione = (
  tipoEstrazione: string,
  params?: GetBackProcedimentiEstrazioneTipoEstrazioneParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<EstrazioneDTO>(
    {
      url: `/framework-bo-procedimenti/procedimenti/estrazione/${tipoEstrazione}`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiEstrazioneTipoEstrazioneQueryKey = (
  tipoEstrazione: string,
  params?: GetBackProcedimentiEstrazioneTipoEstrazioneParams,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/estrazione/${tipoEstrazione}`,
    ...(params ? [params] : []),
  ] as const;

export const getGetBackProcedimentiEstrazioneTipoEstrazioneQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getBackProcedimentiEstrazioneTipoEstrazione>
  >,
  TError = ErrorType<unknown>,
>(
  tipoEstrazione: string,
  params?: GetBackProcedimentiEstrazioneTipoEstrazioneParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiEstrazioneTipoEstrazione>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiEstrazioneTipoEstrazione>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackProcedimentiEstrazioneTipoEstrazioneQueryKey(
      tipoEstrazione,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiEstrazioneTipoEstrazione>>
  > = ({ signal }) =>
    getBackProcedimentiEstrazioneTipoEstrazione(
      tipoEstrazione,
      params,
      requestOptions,
      signal,
    );

  return { queryKey, queryFn, enabled: !!tipoEstrazione, ...queryOptions };
};

export type GetBackProcedimentiEstrazioneTipoEstrazioneQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getBackProcedimentiEstrazioneTipoEstrazione>>
  >;
export type GetBackProcedimentiEstrazioneTipoEstrazioneQueryError =
  ErrorType<unknown>;

export const useGetBackProcedimentiEstrazioneTipoEstrazione = <
  TData = Awaited<
    ReturnType<typeof getBackProcedimentiEstrazioneTipoEstrazione>
  >,
  TError = ErrorType<unknown>,
>(
  tipoEstrazione: string,
  params?: GetBackProcedimentiEstrazioneTipoEstrazioneParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiEstrazioneTipoEstrazione>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetBackProcedimentiEstrazioneTipoEstrazioneQueryOptions(
      tipoEstrazione,
      params,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getBackProcedimentiCsv = (
  params?: GetBackProcedimentiCsvParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<string[]>(
    {
      url: `/framework-bo-procedimenti/procedimenti/csv`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiCsvQueryKey = (
  params?: GetBackProcedimentiCsvParams,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/csv`,
    ...(params ? [params] : []),
  ] as const;

export const getGetBackProcedimentiCsvQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiCsv>>,
  TError = ErrorType<unknown>,
>(
  params?: GetBackProcedimentiCsvParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiCsv>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiCsv>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBackProcedimentiCsvQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiCsv>>
  > = ({ signal }) => getBackProcedimentiCsv(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetBackProcedimentiCsvQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimentiCsv>>
>;
export type GetBackProcedimentiCsvQueryError = ErrorType<unknown>;

export const useGetBackProcedimentiCsv = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiCsv>>,
  TError = ErrorType<unknown>,
>(
  params?: GetBackProcedimentiCsvParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiCsv>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackProcedimentiCsvQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Recupero tutti i campi potenzialmente estraibili in csv per i procedimenti/versione procedimenti pubblicati (per verticale)
 */
export const getBackProcedimentiCsvCampi = (
  params?: GetBackProcedimentiCsvCampiParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<CampoEstraibileCSV[]>(
    {
      url: `/framework-bo-procedimenti/procedimenti/csv/campi`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiCsvCampiQueryKey = (
  params?: GetBackProcedimentiCsvCampiParams,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/csv/campi`,
    ...(params ? [params] : []),
  ] as const;

export const getGetBackProcedimentiCsvCampiQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiCsvCampi>>,
  TError = ErrorType<unknown>,
>(
  params?: GetBackProcedimentiCsvCampiParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiCsvCampi>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiCsvCampi>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBackProcedimentiCsvCampiQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiCsvCampi>>
  > = ({ signal }) =>
    getBackProcedimentiCsvCampi(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetBackProcedimentiCsvCampiQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimentiCsvCampi>>
>;
export type GetBackProcedimentiCsvCampiQueryError = ErrorType<unknown>;

export const useGetBackProcedimentiCsvCampi = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiCsvCampi>>,
  TError = ErrorType<unknown>,
>(
  params?: GetBackProcedimentiCsvCampiParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiCsvCampi>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackProcedimentiCsvCampiQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getBackProcedimentiB2BId = (
  idIstanzaProcedimento: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<Procedimento>(
    {
      url: `/framework-bo-procedimenti/procedimenti/b2b/${idIstanzaProcedimento}`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiB2BIdQueryKey = (
  idIstanzaProcedimento: string,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/b2b/${idIstanzaProcedimento}`,
  ] as const;

export const getGetBackProcedimentiB2BIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiB2BId>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiB2BId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiB2BId>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackProcedimentiB2BIdQueryKey(idIstanzaProcedimento);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiB2BId>>
  > = ({ signal }) =>
    getBackProcedimentiB2BId(idIstanzaProcedimento, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!idIstanzaProcedimento,
    ...queryOptions,
  };
};

export type GetBackProcedimentiB2BIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimentiB2BId>>
>;
export type GetBackProcedimentiB2BIdQueryError = ErrorType<unknown>;

export const useGetBackProcedimentiB2BId = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiB2BId>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiB2BId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackProcedimentiB2BIdQueryOptions(
    idIstanzaProcedimento,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
